import { mediaAPI, videoAPI } from 'services/admin';
import languages from '../../utils/languages';

export const createVideo = async (auth, setAuth, title) => {
  return new Promise((resolve, reject) => {
    const session = auth;

    const data = {
      createdBy: {
        userId: session.getIdToken().payload.sub,
        name: session.getIdToken().payload.username,
      },

      body: { title },
    };

    return videoAPI
      .post(data)
      .then(resp => {
        resolve(resp);
      })
      .catch(error => {
        console.log(error);
      });
  });
};

export const getVideoById = async (
  path,
  auth,
  _setAuth,
  setIsLoading,
  setNotify
) => {
  return new Promise((resolve, reject) => {
    const session = auth;

    const data = {
      createdBy: {
        userId: session.getIdToken().payload.sub,
        name: session.getIdToken().payload.username,
      },
    };

    return videoAPI
      .get(path, data)
      .then(resp => {
        setIsLoading(false);
        resolve(resp);
      })
      .catch(error => {
        setIsLoading(false);
        setNotify({
          isOpen: true,
          message: error.message,
          type: 'error',
          title: 'Ops! Algo deu errado...',
        });
        console.log(error);
      });
  });
};

export const getVersionsById = async (
  path,
  auth,
  _setAuth,
  setIsLoading,
  setNotify
) => {
  return await getVideoById(
    path,
    auth,
    _setAuth,
    setIsLoading,
    setNotify
  );
};

export const getMediaMainById = async (
  auth,
  mediaId,
  setValue,
  setVideoFiles,
  setIdiomaVideo,
  setLegendaIdioma,
  setCanAddAudio,
  setCanAddSubtitle,
  setAudioFiles,
  setAudioIdioma,
  setSubtitleFiles,
  setAuth,
  setNotify,
  setIsLoading
) => {
  let response = await getMediaById(
    auth,
    mediaId,
    setAuth,
    setNotify,
    setIsLoading
  );
  let mediaContent = {
    mediaId: {
      mediaId: mediaId,
      name: response?.fileName,
      audioLanguage: response?.audioLanguage,
      duration: response?.duration,
      submitTimestamp: response?.submitTimestamp,
      completeTimestamp: response?.completeTimestamp,
      status: response?.status
    },
  };
  if (response?.duration) {
    setValue('duration', response?.duration);
  }
  setVideoFiles(mediaContent);
  languages
    .filter(lang => lang.uuid === response?.audioLanguage)
    .map(filteredLang =>
      setIdiomaVideo({ value: filteredLang.uuid, label: filteredLang.name })
    );
  setCanAddSubtitle(false);
  setCanAddAudio(false);
  let subtitles = response?.subtitles;
  if (subtitles?.length > 0) {
    let tempSubs = [];

    for (let sub of subtitles) {
      tempSubs.push({
        name: sub?.language?.fileName || sub?.id,
        label: sub?.language?.name,
        subtitleId: sub?.id,
        accessibility: sub?.accessibility,
      });
    }

    setLegendaIdioma(tempSubs);
    setSubtitleFiles(tempSubs);
  }
  let audioTracks = response?.audioTracks;
  if (audioTracks?.length > 0) {
    let tempTracks = [];
    for (let audio of audioTracks) {
      tempTracks.push({
        name: audio?.language?.fileName || audio?.id,
        label: audio?.language?.name,
        audioTrackId: audio?.id,
        accessibility: audio?.accessibility,
      });
    }
    setAudioFiles(tempTracks);
    setAudioIdioma(tempTracks);
  }
};

const getMediaById = async (
  auth,
  mediaId,
  setAuth,
  setNotify,
  setIsLoading
) => {
  return new Promise((resolve, reject) => {
    const path = `/${mediaId}`;
    const session = auth;

    const data = {
      createdBy: {
        userId: session.getIdToken().payload.sub,
        name: session.getIdToken().payload.username,
      },
    };

    return mediaAPI
      .get(path, data)
      .then(resp => {
        resolve(resp);
      })
      .catch(error => {
        reject(error);
        const errorJson = error.request.response;
        const parseJson = JSON.parse(errorJson);
        setNotify({
          isOpen: true,
          message: parseJson.message,
          type: 'error',
          title: 'Ops! Algo deu errado...',
        });
        console.log(error);
        setIsLoading(false);
      });
  });
};
